import axios from 'axios';

const http = axios.create();

http.interceptors.request.use(
  (config) => config,
  (error) => {
    console.error(error);
    toast('error', 'エラーが発生しました');
    return Promise.reject(error);
  },
);

http.interceptors.response.use(
  (response) => response,
  (error) => {
    switch (error.response.status) {
      case 401: // 認証エラー
        // ログイン画面へリダイレクト
        window.location.href = error.response.data;
        break;
      case 419: // 認証期限切れ
        // 画面リロードでtokenを再セットさせる
        window.location.reload();
        break;
      case 429: // too many request
        toast('error', 'エラーが発生しました。しばらくしてからまたお試しください');
        break;

      case 500: // サーバーエラー
        toast('error', 'サーバーでエラーが発生しました');
        break;

      default:
        toast('error', 'エラーが発生しました');
        break;
    }
    console.error(error);
    return Promise.reject(error);
  },
);

export default http;
